import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ListProjectIndicatorsDetails from '../../../widgets/projectIndicatorsWidgets/ListProjectIndicatorsDetails'
import {
  getProjectIndicators,
  getProjectIndicatorsDetails,
} from '../../../redux/actions/projectIndicatorsDetails'

export default function ProjectIndicatorsDetails() {
  const [schema, setSchema] = useState()
  const [xschema, setXschema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const urlParams = new URLSearchParams(window.location.search)
  const searchCode = urlParams.get('searchCode')
  const year = urlParams.get('year')
  const startDate = urlParams.get('startDate')
  const endDate = urlParams.get('endDate')
  const supTeamLeader = urlParams.get('supTeamLeader')
  const supported = urlParams.get('supported')
  const sector = urlParams.get('sector')

  useEffect(() => {
    console.log('urlParams => ', searchCode)
    // http://localhost:3000/proposal-subproject/project-indicators/details?searchCode=PROGRESS_10&year=&startDate=2565-06-14&endDate=2565-06-14&supTeamLeader=&supported=&sector=

    if (!searchCode) {
      return (
        <SidebarProposal isSubProjectReport>
          <PanalLoadingTemplate />
        </SidebarProposal>
      )
    }

    handleGetSchema(10, 1)
  }, [])

  const handleGetSchema = async (pageSize, pageNumber) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectIndicatorsDetails(
        searchCode,
        year,
        startDate,
        endDate,
        supTeamLeader,
        supported,
        sector,
        pageSize,
        pageNumber
      )

      const xschema = await getProjectIndicators()
      setXschema(xschema.form.searchForm)
      // console.log('_schema', _schema)
      setSchema(_schema)
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProjectReport>
          <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />
          <ListProjectIndicatorsDetails
            schemaIndicators={xschema}
            schema={schema}
            searchCode={searchCode}
            year={year}
            startDate={startDate}
            endDate={endDate}
            supTeamLeader={supTeamLeader}
            supported={supported}
            sector={sector}
          />
        </SidebarProposal>
      )}
    </>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: null,
  errorMessage: null,
  header: 'ภาพรวมโครงการย่อย',
  form: {
    data: {
      totalSize: 3,
      values: [
        {
          id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
          projectCode: '66-00048',
          subProjectCode: '66-00048-01',
          subProjectName: 'การลด ละ เลิก บุหรี่โดยใช้ชุมชนเป็นฐานในชุมชน ตำบล อำเภอ จังหวัด',
          responsiblerLabel: 'นางสาววรรณภา มีเนตรทิพย์',
          granteeSubProjectCode: 'นางสาวชลณิชา อาษา',
          projectCost: 100000,
          projectStartAndendDate: '1 ม.ค. 68 - 30 ธ.ค. 68',
          projectStatus: 'ดำเนินการ',
          totalSize: 3,
        },
        {
          id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
          projectCode: '66-00048',
          subProjectCode: '66-00048-02',
          subProjectName:
            'การลด ละ เลิก บุหรี่โดยใช้ชุมชนเป็นฐานในชุมชนบ้านเวียงหมอก ตำบลห้วยซ้อ อำเภอเชียงของ จังหวัดเชียงราย',
          responsiblerLabel: 'นางสาววรรณภา มีเนตรทิพย์',
          granteeSubProjectCode: 'นางสาวชลณิชา อาษา',
          projectCost: 200000,
          projectStartAndendDate: '1 ม.ค. 68 - 30 ธ.ค. 68',
          projectStatus: 'ดำเนินการ',
          totalSize: 3,
        },
        {
          id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
          projectCode: '66-00048',
          subProjectCode: '66-00048-03',
          subProjectName:
            'การลด ละ เลิก บุหรี่โดยใช้ชุมชนเป็นฐานในชุมชนทดสอบ v.1 การลด ละ เลิก บุหรี่โดยใช้ชุมชนเป็นฐานในชุมชน ตำบลบ้านดู่ อำเภอเมืองเชียงราย จังหวัดเชียงราย',
          responsiblerLabel: 'นางสาววรรณภา มีเนตรทิพย์',
          granteeSubProjectCode: 'นางสาวชลณิชา อาษา',
          projectCost: 300000,
          projectStartAndendDate: '1 ม.ค. 68 - 30 ธ.ค. 68',
          projectStatus: 'ดำเนินการ',
          totalSize: 3,
        },
      ],
    },
  },
}
